import { defineComponent as _defineComponent } from 'vue';
import { cn } from '../../primitives/utils';
import { Sheet, SheetContent } from '../../primitives/sheet';
import SheetDescription from '../../primitives/sheet/SheetDescription.vue';
import SheetHeader from '../../primitives/sheet/SheetHeader.vue';
import SheetTitle from '../../primitives/sheet/SheetTitle.vue';
import { SIDEBAR_WIDTH_MOBILE, useSidebar } from "./utils";
export default /*@__PURE__*/ _defineComponent({
    ...{
        inheritAttrs: false,
    },
    __name: 'Sidebar',
    props: {
        side: { type: String, required: false, default: "left" },
        variant: { type: String, required: false, default: "sidebar" },
        collapsible: { type: String, required: false, default: "offcanvas" },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const { isMobile, state, openMobile, setOpenMobile } = useSidebar();
        const __returned__ = { props, isMobile, state, openMobile, setOpenMobile, get cn() { return cn; }, get Sheet() { return Sheet; }, get SheetContent() { return SheetContent; }, SheetDescription, SheetHeader, SheetTitle, get SIDEBAR_WIDTH_MOBILE() { return SIDEBAR_WIDTH_MOBILE; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
